var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-text-field',{attrs:{"label":"Discount Percentage","type":"number","value":_vm.percent,"suffix":"%","outlined":"","dense":"","hide-details":""},on:{"input":_vm.percentChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }